import type { I18nStore } from './types';
import { create } from 'zustand';
import { defaultLanguage } from '@/i18n/const';
import { getLanguageSetting } from '@/i18n/helper';

export const useI18nStore = create<I18nStore>((set) => ({
  currentLanguage: getLanguageSetting() || defaultLanguage,
  changeLanguage: language => set({ currentLanguage: language }),
}));
